import { createRouterScroller } from 'vue-router-better-scroller'

interface SavedPosition {
  top?: number
  left?: number
  behavior?: ScrollOptions['behavior']
}

function scrollHandler({ savedPosition }: { savedPosition?: SavedPosition }): SavedPosition {
  return savedPosition || { top: 0, left: 0, behavior: 'smooth' }
}

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(
    createRouterScroller({
      selectors: {
        'window': scrollHandler,
        'body': scrollHandler,
        '#main': scrollHandler,
        '#mainsub': scrollHandler,
      },
    }),
  )
})
